import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import { getOverdueTaskCount } from "../services/taskService";
import { toISODate } from "../utils/weekDates";

const TaskOverdueContext = createContext({ overdueCount: 0, refreshOverdueCount: () => {} });

const POLL_INTERVAL_MS = 60000;

// Overdue tasks for the sidebar badge; everyone has a Tasks page, so this always runs.
export function TaskOverdueProvider({ children }) {
  const [overdueCount, setOverdueCount] = useState(0);

  const refreshOverdueCount = useCallback(async () => {
    try {
      setOverdueCount(await getOverdueTaskCount(toISODate(new Date())));
    } catch {
      // The badge is a hint; a failed poll keeps the last count.
    }
  }, []);

  useEffect(() => {
    refreshOverdueCount();
    const interval = setInterval(refreshOverdueCount, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [refreshOverdueCount]);

  return (
    <TaskOverdueContext.Provider value={{ overdueCount, refreshOverdueCount }}>
      {children}
    </TaskOverdueContext.Provider>
  );
}

export const useTaskOverdue = () => useContext(TaskOverdueContext);
